// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"672":"c4228d3e","684":"cef09537","774":"273b255b"}[chunkId] + ".js";
};